export enum AccountQueryKeys {
  Cryptos = 'account/cryptos',
  Fiats = 'account/fiats',
  ByCoin = 'account/by-coin',
}
